/**
 * @desc 导入月度报表分组规则
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(body: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/amazonDateRangeRules/importAmzonDateRangeRulesExcel`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
